import { createAsyncThunk } from '@reduxjs/toolkit';

import { updatePartner } from '@/modules/partner/actions/actions';
import { isTaxProfileRequiresVat } from '@/modules/taxProfile/model/taxProfile';
import { ThunkResult } from '@/shared/actions/thunk-result';
import { CountryCode, TCountryCodes } from '@/shared/models/country-code';

import { onboardingAPI, ISubmitFormResult } from '../api';
import { PayoutsForm, mapPhoLicenseToApi } from '../model/payoutsStep';
import { isStepAccepted } from '../model/stepErrors';
import { namespace } from '../namespace';

let lastRequestId: string | undefined;

type Params = {
  formValues: PayoutsForm;
  countryCode?: TCountryCodes;
};

const submitPayoutsStep = createAsyncThunk(
  `${namespace}/submit-payment-info-step`,
  async (
    params: Params,
    { dispatch, requestId },
  ): Promise<ThunkResult<ISubmitFormResult<PayoutsForm>>> => {
    try {
      if (lastRequestId !== undefined) {
        return { isAlreadyExecuted: true };
      }

      lastRequestId = requestId;

      let formValues = params.formValues;

      if (
        params.countryCode === CountryCode.GreatBritain &&
        !isTaxProfileRequiresVat(params.formValues.taxProfile)
      ) {
        formValues = { ...params.formValues, vatRegNo: '' };
      }

      const result = await onboardingAPI.submitPayoutsStep(formValues);

      if (isStepAccepted(result)) {
        await dispatch(
          updatePartner({
            partnerType: formValues.partnerType,
            legalName: formValues.companyName,
            legalAddress1: formValues.companyAddress,
            companyRegNumber: formValues.companyRegNumber,
            vatRegNo: formValues.vatRegNo,
            inn: formValues.inn,
            legalKpp: formValues.kpp,
            taxProfile: formValues.taxProfile,
            ssn: formValues.ssn,
            ein: formValues.ein,
            dbaName: formValues.dbaName,
            licenseNumber: formValues.licenseNumber,
            hasPhoLicense: mapPhoLicenseToApi(formValues.hasPhoLicense),
            onboarding: result.onboarding,
          }),
        );
      }

      return {
        isSucceed: true,
        result,
      };
    } finally {
      lastRequestId = undefined;
    }
  },
);

export { submitPayoutsStep };
